async function shareArt(artName: String, artDescription: String) {
    const canonical: any = document.querySelector("link[rel=canonical]");
    let url = canonical ? canonical.href : document.location.href;
    const shareDetails = { artName, artDescription, url };
  
    
      if (navigator.share) {
        try {
          await navigator
            .share(shareDetails)
        } catch (error) {
          console.log(error);
        }
      }
    };
  
  
  export default shareArt;